// src/utils/compareSelection.js
import { parseAssetModel, getBatterySlaveIds, BATTERY_TYPE } from './assetConfig';

/**
 * Expands a flat device list into one selectable entry per battery cabinet,
 * using the same model-string parsing the rest of the app relies on.
 */
export function buildBatteryOptions(devices) {
  return (devices || []).flatMap(device => {
    const config = parseAssetModel(device.carProfile?.model);
    const slaveIds = getBatterySlaveIds(config);
    const deviceLabel = device.vehicleId || device.deviceId;
    return slaveIds.map((slaveId, index) => {
      const isDaly = config.type === BATTERY_TYPE.DALYLV;
      const batteryLabel = isDaly
        ? `Battery (Slave ${slaveId})`
        : `Battery ${index + 1} (Slave ${slaveId})`;
      const slaveLabel = isDaly
        ? `Slave ${slaveId}`
        : `Battery ${index + 1} (Slave ${slaveId})`;
      return {
        deviceId: device.deviceId,
        vehicleId: device.vehicleId,
        deviceLabel,
        model: device.carProfile?.model || 'Unknown',
        type: config.type,
        batterySlaveId: slaveId,
        batteryIndex: index,
        batteryLabel,
        slaveLabel,
      };
    });
  });
}

export function groupBatteryOptionsByDevice(options) {
  return options.reduce((groups, option) => {
    if (!groups[option.deviceId]) groups[option.deviceId] = [];
    groups[option.deviceId].push(option);
    return groups;
  }, {});
}

export function selectionKey(option) {
  return `${option.deviceId}_${option.batterySlaveId}`;
}

